import { ChangeDetectorRef, Component, DestroyRef, ElementRef, inject, Input, Renderer2, signal, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { RouterService } from '../../../core/services/router.service';

@Component({
  selector:    'app-burger-menu',
  imports:     [],
  templateUrl: './burger-menu.component.html',
  styleUrl:    './burger-menu.component.scss'
})

export class BurgerMenuComponent {
  readonly isOpen = signal(false);
  readonly isClosing = signal(false);

  public routerService = inject(RouterService);
  private renderer2 = inject(Renderer2);
  private cd = inject(ChangeDetectorRef);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  @Input()
  toggleElementRef: ElementRef;

  @ViewChild('burgerPanel') burgerPanel: ElementRef;

  constructor() {
    // Close on Click outside
    this.renderer2.listen('window', 'click', (e: Event) => {
      if (this.isOpen() &&
        this.toggleElementRef && !this.toggleElementRef.nativeElement.contains(e.target) &&
        this.burgerPanel && !this.burgerPanel.nativeElement.contains(e.target)) {
        this.closeMenu();
        this.cd.markForCheck();
      }
    });
    // Close on Route change
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        if (this.isOpen()) {
          this.closeMenu();
        }
      });
  }

  openMenu() {
    this.isOpen.set(true);
    this.isClosing.set(false);
    document.body.classList.add('no-scroll');
    this.cd.markForCheck();
  }

  closeMenu() {
    this.isClosing.set(true);
    document.body.classList.remove('no-scroll');

    setTimeout(() => {
      this.isOpen.set(false);
      this.isClosing.set(false);
    }, 300); // match animation duration
    this.cd.markForCheck();
  }
}
